import { getLevelCount } from 'a/directorsCut/redux/selectors/curriculumSelectors';
import { REDUX_ACTIONS, GAME_ID, AVAILABLE_LEVEL_INDEXES } from '../../data/constants';

const initState = {
  isOnboarded: false,
  wasCharactersStartAlertDisplayed: false,
  wasThoughtsStartAlertDisplayed: false,
  highestLevelEarned: 0,
};

const sessionReducer = (state = initState, { type, gameId, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    // change screen according to action payload
    case REDUX_ACTIONS.COMPLETE_ONBOARDING:
      return {
        ...state,
        isOnboarded: true,
      };

    case REDUX_ACTIONS.SET_WAS_CHARACTERS_START_ALERT_DISPLAYED:
      return {
        ...state,
        wasCharactersStartAlertDisplayed: true,
      };

    case REDUX_ACTIONS.SET_WAS_THOUGHTS_START_ALERT_DISPLAYED:
      return {
        ...state,
        wasThoughtsStartAlertDisplayed: true,
      };
    case REDUX_ACTIONS.ROUND_END: {
      const { levelIndex, isSuccess, isEarlyExit } = payload;
      if (isSuccess && !isEarlyExit) {
        const indexInLevelArray = AVAILABLE_LEVEL_INDEXES.indexOf(levelIndex);
        const nextIndexInLevelArray = Math.min(indexInLevelArray + 1, getLevelCount() - 1);
        const highestLevelEarned = AVAILABLE_LEVEL_INDEXES[nextIndexInLevelArray];
        return {
          ...state,
          highestLevelEarned,
        };
      }
      return state;
    }

    default:
      return state;
  }
};

export default sessionReducer;
